module.exports = __webpack_public_path__ + "img/tuxsuite-build-set.b42c95fd.svg";